import { SpecialFont, StoreSpecialFont } from '@/types';
import { getSupportedGlyphsRegExp } from '@/model/font/getSupportedGlyphsRegExp';

export function mapSpecialFont(font: SpecialFont): StoreSpecialFont {
  return {
    ...font,
    id: font.id.toString(),
    title: decodeURIComponent(font.title),
    supportedGlyphs: getSupportedGlyphsRegExp(decodeURIComponent(font.restrict).split('')),
    identifier: `specialfont_${font.id}`,
    type: 'special',
  };
}
